<script lang="ts" generics="Item">
  interface Props {
    name: string;
    items: Item[];
    key: (item: Item) => string | number;
    isChosen: (item: Item) => boolean;
    onChoose: (item: Item) => void;
    title: (item: Item) => string;
    subtitle?: (item: Item) => string;
    monospaceSubtitle?: boolean;
    isDisabled?: (item: Item) => boolean;
    emptyText?: string;
    footnote?: string;
  }

  let {
    name,
    items,
    key,
    isChosen,
    onChoose,
    title,
    subtitle,
    monospaceSubtitle = false,
    isDisabled = () => false,
    emptyText = '',
    footnote = '',
  }: Props = $props();
</script>

<div class="options">
  {#each items as item (key(item))}
    {@const disabled = isDisabled(item)}
    <label class="option" class:selected={isChosen(item)} class:disabled>
      <input type="radio" {name} checked={isChosen(item)} {disabled} onchange={() => onChoose(item)} />
      <span class="row">
        <span class="title">{title(item)}</span>
        {#if subtitle}<span class="note" class:mono={monospaceSubtitle}>{subtitle(item)}</span>{/if}
      </span>
    </label>
  {:else}
    {#if emptyText}<p class="note">{emptyText}</p>{/if}
  {/each}
  {#if footnote}<p class="note">{footnote}</p>{/if}
</div>

<style>
  .options {
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
  }
  .option {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    gap: var(--space-3);
    padding: var(--space-3);
    border: 1px solid transparent;
    border-radius: var(--radius-sm);
    cursor: pointer;
  }
  .option:hover {
    background: var(--bg-hover);
  }
  .option:has(input:focus-visible) {
    outline: 2px solid var(--accent);
    outline-offset: 2px;
  }
  .option.selected {
    border-color: var(--border-accent);
    background: var(--accent-bg);
  }
  .option.disabled {
    cursor: default;
    opacity: 0.6;
  }
  .option input {
    width: auto;
    padding: 0;
  }
  .row {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .title {
    color: var(--text-primary);
    font-weight: 500;
  }
  .note {
    margin: 0;
    color: var(--text-tertiary);
    font-size: 12px;
  }
</style>
